// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"41":"2e10197b","193":"6c5b641a","208":"0e5845d0","257":"f26c7837","289":"be61c8dc","395":"13d2a35e","427":"717057bd","432":"f67dc835","443":"b1723dc4","450":"0953c3e2","600":"41893b74","674":"ad8f72fa"}[chunkId] + ".chunk.js";
};